export default "__VITE_ASSET__kS_ZDiVp__"